import { type OpenApiSchemaProductStock } from '#shared/api/schema';

export const getProductStockInfo = (stocks: OpenApiSchemaProductStock[]) => {
    if (!stocks || stocks?.length === 0) {
        return { min: Infinity, max: -Infinity, sum: 0 };
    }

    const { min, max, sum } = stocks?.reduce(
        (acc, stock) => {
            const { min, max, sum } = acc;
            const quantity = stock.total_quantity;

            return {
                min: Math.min(min, quantity),
                max: Math.max(max, quantity),
                sum: sum + quantity,
            };
        },
        { min: Infinity, max: -Infinity, sum: 0 }
    );

    return {
        min,
        max,
        sum,
    };
};
